/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react"
import styled from "styled-components"
import ResultCard from "./ResultCard"

export default function Result({
  peopleName,
  page,
  setPage,
  summary1,
  summary2,
  data,
  reset,
  API,
  GetAndShare,
  resultRoleJudge,
  phone,
  setPhone,
  setResult,
  setAnswerInfoHandler,
  saveAnswerInfoToAPI,
  getTraitId
}) {
  const [resultData, setResultDate] = useState({})

  useEffect(() => {
    const resultfilter = data.filter(value => {
      return value.roleID === resultRoleJudge(summary1, summary2)
    })[0]

    setResultDate(resultfilter)
  }, [])

  useEffect(() => {
    setResult(resultData.name)
  }, [resultData])

  return (
    <Wrapper>
      <ResultCard
        roleID={resultData.roleID}
        peopleName={peopleName}
        page={page}
        setPage={setPage}
        name={resultData.name}
        AKA={resultData.AKA}
        chance={resultData.chance}
        saying={resultData.saying}
        summary={resultData.summary}
        analysis={resultData.analysis}
        investment={resultData.investment}
        befit={resultData.befit}
        img={resultData.img}
        resultImg={resultData.resultImg}
        reset={reset}
        API={API}
        GetAndShare={GetAndShare}
        phone={phone}
        setPhone={setPhone}
        setAnswerInfoHandler={setAnswerInfoHandler}
        saveAnswerInfoToAPI={saveAnswerInfoToAPI}
        getTraitId={getTraitId}
      />
    </Wrapper>
  )
}

const Wrapper = styled.div``
